import PropTypes from "prop-types"
import React from "react"
import CountUp from "react-countup"
import Visibility from "../../visibility"

const MiscPercentage = ({ block, value, icon, learnMore, background, italic, animate }) => (
  <div
    className={`flex flex-column col col-12 ${background? "bg-mercer-glass-dark": ""} p1 md-p2 relative`}
    style={{
      minHeight: "100%"
    }}
  >
    <div className="flex-auto col col-12">
    <Visibility>
      {({ isVisible }) => (
        <React.Fragment>
          <div style={{height: "260px"}}>
            <h4 className="misc-percentage-title fg-mercer-gray-dark uppercase center mt0 mb1 letter-space-1.5" style={{fontSize: "18px"}}>{block.title}</h4>
            <div className="col col-12 center">
              <div className="misc-percentage-icon" >
                <div className="bg-center bg-contain" style={{backgroundImage: `url(${icon})`, width:"120px", height:"120px", margin: "0px"}}></div>
              </div>
            </div>
            <div className="col col-12 center">
              <h1 className="fg-mercer-blue-dark large-digi mt1 mb0 line-height-2">
                {isNaN(value) || value === 0 ? (
                  <React.Fragment>NA</React.Fragment>
                ) : (
                  <React.Fragment>
                    <CountUp duration={2.5} useEasing={true}  end={animate && isVisible ? value : 0} decimals={parseFloat(value).toFixed(2).split(".")[1][1] === "0" ? 1 : 2} />%
                  </React.Fragment>
                )}
              </h1>
            </div>
          </div>
          <div className="col col-12 center mb1 line-height-1">
            <p className={` ${italic? "italic gray": "fg-mercer-gray-dark"}`}>{block.content}</p>
          </div>
        </React.Fragment>
      )}
    </Visibility>
    </div>
    {learnMore && (
      <div className="col col-12 center">
        <a href={block.link1} target="_parent" className="btn btn-primary bg-mercer-gray-light fg-mercer-gray-dark col col-12">Learn More ></a>
      </div>
    )}
  </div>
)

MiscPercentage.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    link1: PropTypes.string,
  }),
  value: PropTypes.number,
  icon: PropTypes.string,
  learnMore: PropTypes.bool,
  background: PropTypes.bool,
  italic: PropTypes.bool,
  animate: PropTypes.bool,
}

MiscPercentage.defaultProps = {
  block: {
    title: ``,
    content: ``,
    link1: ``,
  },
  value: 0,
  learnMore: true,
  animate: true,
}

export default MiscPercentage
